import React from 'react'
import "../../styles/home.css";
import { Box, Grid, Typography } from "@mui/material";
import img1 from "../../images/faqbanner.png";
import Navbar from "../Navbar";
export default function FaqBanner() {
  return (
    <>
        <Box className="homeBanner">
        <Box pt={4}>
          <Navbar />
          <Box mt={8}>
            <Grid container spacing={2}>
              <Grid item md={6}>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "start",
                    flexDirection: "column",
                    height: "100%",
                    fontFamily: "Inter",
                  }}
                >
                  <Box>
                    <Typography
                      sx={{
                        color: "#3665D0",
                      }}
                      className="subHeading2Mid"
                    >
                      Lorem Ipsum
                    </Typography>
                  </Box>
                  <Box>
                    <Typography
                      sx={{
                        fontFamily: "Inter",
                        fontWeight: 700,
                        fontSize: "55px",
                        lineHeight: "120%",
                        display: "block",
                        marginTop: "1%",
                      }}
                    >
                     FAQ
                    </Typography>
                    <Typography className="homeBanner-span4 text2Mid" pt={1}>
                      Each month, more than 3 million job seekers turn to
                      website in their search for work, making over 140,000
                      applications every single day
                    </Typography>
                  </Box>
                </Box>
              </Grid>
              <Grid item md={6}>
                <Box sx={{pl:{xs:0, md:15}}}>
                  <img
                    src={img1}
                    alt="bannerCouple"
                   style={{height:'500px'}}
                  />
                </Box>
              </Grid>
            </Grid>
          </Box>
        </Box>
      </Box>
    </>
  )
}
